module.exports = __webpack_public_path__ + "static/snow-accumulation-legend-cm-1c1882db8affb7fbbd54f6b247c25f9c.svg";